import * as ng from 'angular';
import * as _ from 'underscore';
import * as $ from 'jquery';
import * as moment from 'moment';

import { camelCase } from '.';

export class ApiHelperService {
   static $inject:string[] = ['$q', '$rootScope', '$http'];
   constructor(
      private $q:ng.IQService,
      private $rootScope:ng.IScope,
      private $http:ng.IHttpService
   ) { }

   static extractDataUris(
      data:any,
      parentPath:string = '',
      result:{ [id: string] : string } = { }
   ):{ [id: string] : string } {
      for (let key in data) {
         let keyPath = parentPath + key;
         let val = data[key];

         if (ng.isString(val)) {
            if (val.indexOf('data:') == 0) {
               data[key] = null;
               result[keyPath] = val;
            }
         } else if (ng.isObject(val)) {
            this.extractDataUris(val, keyPath + '.', result);
         }
      }

      return result;
   }

   static buildMultipartRequest(model: any, dataUris: { [id: string]: string}): Blob {
      let boundary = '', newline = '\r\n';
      let parts = [];

      for (let i = 0; i < 40; i++) {
         boundary += Math.floor(Math.random() * 36).toString(36);
      }

      // start marker
      parts.push(`--${boundary}${newline}`);
      parts.push(`Content-Disposition: form-data; name="model"${newline}`);
      parts.push(`Content-Type: application/json${newline}`);
      parts.push(newline);
      parts.push(JSON.stringify(model));

      for (let key in dataUris) {
         // next part marker
         parts.push(`${newline}--${boundary}${newline}`);

         let p = parseDataUrl(dataUris[key]);

         parts.push(`Content-Disposition: form-data; name="${key}"${newline}`);
         parts.push(`Content-Type: ${p.mimeType}${newline}`);
         parts.push(newline);
         parts.push(p.data);
      }

      // end parker
      parts.push(`${newline}--${boundary}--${newline}`);

      return new Blob(parts, {type: `multipart/mixed; boundary=${boundary}`});
   }

   static multipartTransform(data: any):Blob {
      if (data && data.settings) {
         let dataUrls = this.extractDataUris(data.settings);
         if (_.keys(dataUrls).length > 0) {
            return this.buildMultipartRequest(data, dataUrls);
         }
      }

      return null;
   }

   private parseErrors(response:ng.IHttpPromiseCallbackArg<any>) {
      if (response.status !== 400) {
         return;
      }

      var errors = [];

      if (response.data.errors) {
         errors = _.map(response.data.errors, (messages, key:string) => {
            return {
               field: camelCase(key),
               message: messages[0]
            };
         });
      } else if (ng.isString(response.data)) {
         errors.push(response.data);
      }

      if (errors.length > 0) {
         this.$rootScope.$broadcast('form.invalid', errors);
      }
   }

   // TODO: consider node package url-parse
   getApiUrl(uri:string, query?:{}):string {
      const url = new URL(window.location.href);
      let urlHost = url.host.toLowerCase();
      let urlProtocol = url.protocol;
      // let urlHostName = url.hostname.toLowerCase();
      // let urlPort = url.port;

      let isAbsolute = _.any(['//', 'http:', 'https:'], (prefix) => {
         return uri.indexOf(prefix) == 0;
      });

      if (!isAbsolute) {
         uri = `${urlProtocol}//${urlHost}/api/${uri}`;
      }

      if (query) {
         // 'true' turns on traditional handling for arrays
         // i.e. {a: [1,2]} => ?a=1&a=2
         uri = uri + '?' + $.param(query, true);
      }

      return uri;
   }

   // ideally return type would be...
   // {total:number,list:T}|ng.IHttpPromiseCallbackArg<T>
   // but union types don't work that way
   get(uri:string, query?:{}):ng.IPromise<any> {
      uri = this.getApiUrl(uri, formatQuery(query));

      return this.$http.get(uri).then((response:ng.IHttpPromiseCallbackArg<any>) => {
         if (response.status == 200) {
            this.$rootScope.$broadcast('form.valid');

            let total:string = response.headers('X-TotalRecords');
            if (ng.isString(total) && total !== '') {
               return {
                  total: parseInt(total),
                  list: response.data
               };
            }

            return response.data;
         } else {
            return this.$q.reject(response);
         }
      }).catch((response) => {
         this.parseErrors(response);
         return this.$q.reject(response);
      });
   }

   post<T = any>(uri:string, data:any):ng.IPromise<T> {
      let config = {
         method: 'POST',
         url: this.getApiUrl(uri),
         data: data,
         headers: {
            __XHR__: () => {
               return (xhr) => {
                  // NOTE: This event is broadcast to all
                  xhr.upload.addEventListener('progress', (event) => {
                     this.$rootScope.$broadcast('upload.progress', ((event.loaded/event.total) * 100) + "%");
                  });
               };
            }
         }
      };

      // when data is string assume application/x-www-form-urlencoded (e.g. oauth/token)
      if (ng.isString(data)) {
         config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }

      // configure request for file upload when data contains a file
      if (data instanceof FormData) {
         config.headers['Content-Type'] = undefined;
         config['transformRequest'] = ng.identity;
      }

      // multipartTransform will null props with data Uri's which will cause
      // images displayed in editors to disappear while request is uploading
      // deep copy to avoid this, but memory usage could become a concern
      data = ng.copy(data);

      let blob = ApiHelperService.multipartTransform(data);
      if (blob != null) {
         config.data = blob;
         config.headers['Content-Type'] = blob.type;
      }

      // NOTE: we can return 207's now also
      return this.$http<T>(config).then((response:ng.IHttpResponse<T>) => {
         if (response.status >= 200 && response.status <= 204) {
            this.$rootScope.$broadcast('form.valid');
            return response.data;
         } else {
            return this.$q.reject(response);
         }
      }).catch((response:ng.IHttpResponse<T>) => {
         this.parseErrors(response);
         return this.$q.reject(response);
      });
   }

   del(uri) {
      return this.$http.delete<void>(this.getApiUrl(uri));
   }
}

ng.module('e360')
   .service('apiHelper', ApiHelperService);

function parseDataUrl(dataUrl:string):{ mimeType:string, data:Uint8Array } {
   // data:image/jpeg;base64,[bytes...]

   let urlParts = dataUrl.split(';base64,');
   let base64data = urlParts.pop();
   let mimeType = urlParts.shift().slice(5);

   let raw = atob(base64data);
   let data = new Uint8Array(raw.length);

   for (let i = 0; i < raw.length; i++) {
      data[i] = raw.charCodeAt(i);
   }

   return { mimeType: mimeType, data: data };
}

/**
 * Translate query parameters common to data list api endpoints into format
 * expected by backend.
 */
function formatQuery(query:{}) {
   if (!query)
      return;

   query = ng.copy(query);

   // this duplicates formats in utils service and date-time-picker directive
   // ideally date formats and/or date parsing would be centralized
   // BUT I don't like that utils service thing... maybe filters instead?
   const inputDateFmt = 'MM/DD/YYYY HH:mm A';
   const serverDateFmt = 'YYYY-MM-DD[T]HH:mm:ss';

   for (let key of ['startDate', 'endDate']) {
      if (query[key]) {
         query[key] = moment(query[key], inputDateFmt).format(serverDateFmt);
      }
   }

   if (query['page']) {
      query['offset'] = (query['page'] - 1) * query['limit'];
   }

   return query;
}
